import type { CookieCategory } from "../domain/cookie-category";
import { OneTrust } from "../infra/one-trust";
import { isConsentGivenUseCase } from "../use-cases/is-consent-given";

export const isConsentGivenFor = (category: keyof CookieCategory): boolean =>
  isConsentGivenUseCase({
    privacyManager: OneTrust,
    category,
  });
